module.exports = __webpack_public_path__ + "static/media/el-parque.33efcaf4.png";